const formatTimeAgo = (iso) => {
  if (!iso) return null;
  const seconds = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (seconds < 60) return "just now";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo ago`;
  return `${Math.floor(months / 12)}y ago`;
};

const ProjectList = ({
  projects,
  selectedId,
  editingId,
  draftName,
  onAddProject,
  onSelectProject,
  onDeleteProject,
  onStartEdit,
  onDraftNameChange,
  onCommitEdit,
  onCancelEdit,
}) => (
  <section className="pcm-projects" data-testid="project-list-section">
    <div className="pcm-projects-header" data-testid="project-list-header">
      <h2 className="pcm-section-title" data-testid="projects-heading">
        Projects
      </h2>
      <button
        type="button"
        className="pcm-add-project"
        onClick={onAddProject}
        data-testid="add-project-button"
      >
        + Add Project
      </button>
    </div>
    <div className="pcm-project-list" data-testid="project-list">
      {projects.map((project, index) => {
        const isEditing = editingId === project.id;
        const isActive = project.id === selectedId;

        return (
          <div
            key={project.id}
            className={`pcm-project-row ${isActive ? "active" : ""}`}
            data-testid={`project-list-item-${project.id}`}
            style={{ animationDelay: `${index * 0.04}s` }}
          >
            {isEditing ? (
              <input
                type="text"
                value={draftName}
                onChange={onDraftNameChange}
                onBlur={() => onCommitEdit(project)}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    event.preventDefault();
                    onCommitEdit(project);
                  }
                  if (event.key === "Escape") {
                    event.preventDefault();
                    onCancelEdit();
                  }
                }}
                className="pcm-project-input"
                autoFocus
                data-testid={`project-name-edit-${project.id}-input`}
              />
            ) : (
              <button
                type="button"
                className="pcm-project-select"
                onClick={() => onSelectProject(project.id)}
                onDoubleClick={() => onStartEdit(project)}
                aria-pressed={isActive}
                data-testid={`select-project-${project.id}-button`}
              >
                <span className="pcm-project-info">
                  <span
                    className="pcm-project-name"
                    data-testid={`project-name-${project.id}`}
                  >
                    {project.name}
                  </span>
                  {formatTimeAgo(project.updatedAt) && (
                    <span className="pcm-project-age" data-testid={`project-age-${project.id}`}>
                      {formatTimeAgo(project.updatedAt)}
                    </span>
                  )}
                </span>
              </button>
            )}
            <button
              type="button"
              className="pcm-delete-button"
              onClick={() => onDeleteProject(project.id)}
              data-testid={`delete-project-${project.id}-button`}
            >
              Delete
            </button>
          </div>
        );
      })}
    </div>
  </section>
);

export default ProjectList;